
export const playSound = (sound: HTMLAudioElement) => {
  sound.currentTime = 0;
  sound.play().catch(()=> {
    // ignore
  });
}
